import { Injectable } from '@angular/core';

export interface GlobalFilters {
  tenantId?: number;
  years?: number[];
  year?: number;
  adminId?: number;
  analysisId?: number;
}

/**
 * In-memory filter context for the currently selected tenant, shared across
 * pages: the last Year(s) / Administration / Analysis selection is restored
 * automatically when a page loads its options, so users don't re-select the
 * same filters while navigating. The state belongs to one tenant context —
 * it is destroyed on tenant change (see FullComponent.onTenantChange), after
 * which pages default their filters from the latest available data. Only the
 * selected tenant itself is persisted (localStorage) for future sessions.
 * Pages must validate saved values against their loaded options before
 * applying them.
 */
@Injectable({ providedIn: 'root' })
export class FilterStateService {
  private state: GlobalFilters = {};

  get(tenantId: number): GlobalFilters {
    return this.state.tenantId === tenantId ? this.state : {};
  }

  patch(tenantId: number, patch: Partial<GlobalFilters>): void {
    this.state = { ...this.get(tenantId), ...patch, tenantId };
  }

  reset(): void {
    this.state = {};
  }
}
